import React from 'react';
import Svg from '../Svg';
import { SvgProps } from '../types';

interface LogoProps extends SvgProps {
    isDark: boolean;
}

const Logo: React.FC<LogoProps> = ( props ) => {
    return (
        <Svg viewBox="0 0 700 185" { ...props }>
            <image href="/images/logo/logo-horizontal.png"/>
        </Svg>
    );
};

export default React.memo( Logo, ( prev, next ) => prev.isDark === next.isDark );
